import styled from '@emotion/styled'

import { system } from '../../../theme'
import type { ICard } from './Card.types'
export const StyledCard = styled.div<ICard>`
  width: 100%;
  position: relative;
  border: 1px solid ${() => system.colors.neutral200};
  background: ${({ backgroundColor }) =>
    system.colors[backgroundColor || 'white']};
  padding: var(--mantine-spacing-lg);
  border-radius: 8px;
  box-shadow: ${({ elevation = 0 }) => {
    switch (elevation) {
      case 'elevation1':
        return system.shadows.elevation1
      case 'elevation2':
        return system.shadows.elevation2
      case 'elevation3':
        return system.shadows.elevation3
      case 'elevation4':
        return system.shadows.elevation4
      case 'elevation5':
        return system.shadows.elevation5
      case 'elevation6':
        return system.shadows.elevation6
      case 'elevation7':
        return system.shadows.elevation7
      default:
        return 'none'
    }
  }};
  ${({ active }) => {
    if (!active) return ''

    return `
      border: 1px solid ${system.colors.primary700};
      box-shadow: 0px 1px 7px #98F1DB;
    `
  }};
`

export const LabelContainer = styled.div<ICard>`
  margin-bottom: 8px;
`

export const HintContainer = styled.div<ICard>`
  margin-top: 4px;
`

export const StyledIcon = styled.i`
  margin-right: 4px;
`
